import { render, staticRenderFns } from "./SendPoll.vue?vue&type=template&id=ffcc7184&scoped=true&"
import script from "./SendPoll.vue?vue&type=script&lang=ts&"
export * from "./SendPoll.vue?vue&type=script&lang=ts&"
import style0 from "./SendPoll.vue?vue&type=style&index=0&id=ffcc7184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc7184",
  null
  
)

export default component.exports